import moment from 'moment/moment'
import { AutocompleteOption, GETCriteriaValueType } from 'src/types'
import { DateRangeValue } from '@microservices/wiskey-react-components'

import {
  getSecondsArrayForSearchAssistantFilter,
  getSecondsFromTime,
  isObjectValueType,
} from '@helpers'
import {
  FIELD_VALUE_FORMAT,
  FIELD_VALUE_TYPE,
  SEARCH_FIELD_TYPE,
  ValueTypeForRequest,
} from '@constants'

import { getDateTimeRange } from './getDateTimeRange'
import { truncateDateTimeToMinute } from './truncateDateTimeToMinute'

export type RelativeType = [DateRangeValue, string, string]

export const getRelativeDateWithEmptyDate = (
  storedValue: GETCriteriaValueType
): ValueTypeForRequest => {
  if (storedValue.valueType === FIELD_VALUE_TYPE.DATETIME) {
    if (
      storedValue.fieldType === SEARCH_FIELD_TYPE.RELATIVE_VALUE &&
      Array.isArray(storedValue.value) &&
      !storedValue.value[0]
    ) {
      return [truncateDateTimeToMinute(moment()), ...storedValue.value.slice(1)] as RelativeType
    }

    if (storedValue.fieldType === SEARCH_FIELD_TYPE.EXACT_VALUE) {
      return [storedValue.value as string]
    }

    if (storedValue.fieldType === SEARCH_FIELD_TYPE.DAILY_RANGE && storedValue.value) {
      return getDateTimeRange(storedValue.value)
    }

    return storedValue.value as string | [DateRangeValue, DateRangeValue]
  }

  if (Boolean(storedValue.isFilterByObject) && Array.isArray(storedValue.value)) {
    return (storedValue.value as AutocompleteOption[]).map(obj => obj.id)
  }

  if (isObjectValueType(storedValue.valueType) && Array.isArray(storedValue.value)) {
    return (storedValue.value as AutocompleteOption[]).map(obj => obj.id)
  }

  if (storedValue.isGroupRelated && Array.isArray(storedValue.value)) {
    const valueWithOptions = storedValue.value as AutocompleteOption[]

    return valueWithOptions.map(value => value.id)
  }

  if (storedValue.valueFormat === FIELD_VALUE_FORMAT.TIME && storedValue.value) {
    return getSecondsArrayForSearchAssistantFilter(
      getSecondsFromTime(storedValue.value as string),
      storedValue.searchRule
    )
  }

  return [storedValue.value] as ValueTypeForRequest
}
